<template>
  <div class="header-wrap">
    <div class="line"></div>
    <div class="top">
      <div class="title">
        <span class="chinese">中鹏(浙江)机械有限公司</span>
        <span class="english">Zhongpeng (Zhejiang) Machinery Co., Ltd</span>
      </div>
      <van-popover
        v-model="showPopover"
        trigger="click"
        :actions="actions"
        @select="onSelect"
        :getContainer="getContainer"
        placement="bottom-end"
      >
        <template #reference>
          <img class="menu" src="../../../assets/images/mobile/menu.png">
        </template>
      </van-popover>
    </div>
  </div>
</template>

<script>

export default {
  name: "Header",
  data () {
    return {
      showPopover: false,
      actions: [
        {
          text: '首页'
        },
        {
          text: '关于我们'
        },
        {
          text: '产品中心'
        },
        {
          text: '案例中心'
        },
        {
          text: '联系我们'
        }
      ]
    }
  },
  methods: {
    onSelect (action) {
      if (action.text === '关于我们') {
        this.$router.push({path: '/mb_about'})
      } else if (action.text === '产品中心') {
        this.$router.push({path: '/mb_product'})
      } else if (action.text === '案例中心') {
        this.$router.push({path: '/mb_project'})
      } else if (action.text === '联系我们') {
        this.$router.push({path: '/mb_contact'})
      } else {
        this.$router.replace({path: '/mb_home'})
      }
    },
    getContainer () {
      return this.$el || {}
    },
  }
}
</script>

<style lang="less" scoped>
.header-wrap {
  width: 100%;
  overflow-x: hidden;
  background-image: url("../../../assets/images/mobile/bg.png");
  .line {
    height: 0.06rem;
    background: #3a8ee6;
  }
  .top {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 0.16rem;
    .title {
      display: flex;
      flex-direction: column;
      color: #000;
      flex: 1;
      .chinese {
        font-size: 0.48rem;
      }
      .english {
        font-size: 0.3rem;
      }
    }
    .menu {
      width: 1.3rem;
      height: 1.3rem;
    }
  }
  /deep/ .van-popover__action {
    width: 4rem;
    height: 1.5rem;
    font-size: 0.6rem !important;
  }
}
</style>
